export enum HarnessType {
  OBD2YCable = 'OBD 2 Y Cable',
  OBD2Cable = 'OBD 2 Cable',
  J1939YCable = 'J1939 Y Cable (9 Pin - Green)',
  J1939Cable = 'J1939 Cable (9 Pin - Green)',
  J1708YCable = 'J1708 Y Cable (6 Pin - Grey)',
  J1708Cable = 'J1708 Cable (6 Pin - Grey)',
  Wire3 = '3 Wire',
}
export interface Harness {
  id: number;
  serial: string;
  assigned: boolean;
  type: HarnessType;
}
